import React, { useState } from 'react';
import './LandingPage.css';
import AuthModal from '../Auth/AuthModal';

const LandingPage: React.FC = () => {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState<'login' | 'signup'>('login');

  const handleAuth = (mode: 'login' | 'signup') => {
    setAuthMode(mode);
    setShowAuthModal(true);
  };

  return (
    <div className="landing-page">
      <div className="landing-content">
        <div className="landing-left">
          <h1>ChatGPT</h1>
          <p className="subtitle">Your AI-powered conversation assistant</p>
          <div className="feature-list">
            <div className="feature-item">
              <span className="feature-icon">🤖</span>
              <div className="feature-text">
                <h3>Advanced AI Chat</h3>
                <p>Engage in natural conversations with our state-of-the-art AI</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon">💡</span>
              <div className="feature-text">
                <h3>Smart Responses</h3>
                <p>Get intelligent answers to your questions instantly</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon">🔒</span>
              <div className="feature-text">
                <h3>Secure & Private</h3>
                <p>Your conversations are protected and private</p>
              </div>
            </div>
          </div>
        </div>
        <div className="landing-right">
          <div className="auth-container">
            <h2>Get started</h2>
            <div className="auth-buttons">
              <button 
                className="auth-button login"
                onClick={() => handleAuth('login')}
              >
                Log in
              </button>
              <button 
                className="auth-button signup"
                onClick={() => handleAuth('signup')}
              >
                Sign up
              </button>
            </div>
            <p className="try-text">Try it free</p>
          </div>
        </div>
      </div>
      <footer className="landing-footer">
        <div className="footer-content">
          <span>© 2025 ChatGPT</span>
          <div className="footer-links">
            <a href="#">Terms of use</a>
            <a href="#">Privacy policy</a>
          </div>
        </div>
      </footer>
      <AuthModal 
        isOpen={showAuthModal} 
        onClose={() => setShowAuthModal(false)} 
        initialMode={authMode}
      />
    </div>
  );
};

export default LandingPage;
